// Tab keys are part of the /support/:tab? URL contract - they must stay
// identical to the ones the old VideoInstructions component used, since
// TermsAndConditionsEdit deep-links to '/support/terms-and-conditions' and
// e2e/fixtures/routeMatrix.ts has one row per key.
export const SUPPORT_TAB_KEYS = [
    'instructions',
    'help',
    'terms-and-conditions',
    'student-manual',
    'supervision-manual',
    'lector-manual',
] as const;

export type SupportTabKey = typeof SUPPORT_TAB_KEYS[number];
